function setCookie(name, value, minutes) {
  document.cookie = `${name}=${value};max-age=${minutes * 60};path=/`;
}
function getCookie(name) {
  const cookies = document.cookie.split(";");
  const foundCookie = cookies.find((cookie) => {
    const [cookieName] = cookie.split("=");
    return cookieName.trim() === name;
  });
  return foundCookie?.split("=")[1];
}
class Geolocator extends HTMLElement {
  geolocatorScript;
  countryDataArray;
  geolocatorContentTemplate;
  geolocatorContentPlaceholder;
  modal;
  closeModalButton;
  closeCountryListModalButton;
  countryModalToggle;
  countryListModal;
  countryListModalToggles;
  countryListButtons;
  stayButton;
  leaveButton;
  overlay;
  constructor() {
    super();
    this.getBrowsingContext = this.getBrowsingContext.bind(this);
  }
  async connectedCallback() {
    this.initDataAndElements();
    this.addEventListeners();
    this.handleGeolocationCookie();
    const isCookied = getCookie("geolocation");
    if (isCookied) {
      console.log("Geolocation cookie is set. Geolocator will not run.");
      return;
    }
    const browsingContext = await this.getBrowsingContext();
    const activeCountry = this.getActiveCountryAndLanguage();
    const recommendedMatch = this.getRecommendedMatch(browsingContext);
    if (recommendedMatch?.handle === activeCountry.country) {
      console.log("Recommended match is the same as the active country. Geolocator will not run.");
      return;
    }
    this.toggleGeolocator();
    this.setupGeolocatorContent(recommendedMatch);
  }
  handleGeolocationCookie() {
    const urlParams = new URLSearchParams(window.location.search);
    const geolocation = urlParams.get("geolocation");
    if (geolocation) {
      setCookie("geolocation", geolocation, 30);
    }
  }
  toggleGeolocator() {
    this.classList.toggle("tw:hidden");
    this.setAttribute("geolocation-modal-active", this.getAttribute("geolocation-modal-active") === "true" ? "false" : "true");
    setTimeout(() => {
      this.modal.classList.toggle("active");
    }, 300);
  }
  setupGeolocatorContent(recommendedMatch) {
    const geolocatorContent = this.geolocatorContentTemplate.content.cloneNode(true);
    const content = geolocatorContent.querySelector(`[data-id="${recommendedMatch.id}"]`);
    if (content) {
      this.geolocatorContentPlaceholder.appendChild(content);
    }
    this.countryModalToggle = this.querySelector(".country-modal-toggle");
    this.stayButton = this.querySelector(".stay-button");
    this.leaveButton = this.querySelector(".leave-button");
    this.countryModalToggle.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggleCountryListModal(this.countryModalToggle);
    });
    this.stayButton.addEventListener("click", (event) => {
      event.preventDefault();
      setCookie("geolocation", recommendedMatch.handle, 30);
      this.toggleGeolocator();
    });
    this.leaveButton.addEventListener("click", (event) => {
      event.preventDefault();
      const { locale, handle, type, url } = this.leaveButton.dataset;
      setCookie("geolocation", handle, 30);
      const isMarket = type === "market";
      if (!isMarket) {
        if (url) {
          window.location.href = url;
        } else {
          window.location.href = `${window.location.href}?geolocation=${handle}`;
        }
        return;
      }
      this.handleMarketSwitch(handle, locale);
    });
  }
  toggleCountryListModal(trigger) {
    const geoLocatorActive = this.getAttribute("geolocation-modal-active") === "true";
    const isInModalTrigger = trigger.dataset.inmodaltoggle === "true";
    if (isInModalTrigger && !geoLocatorActive) {
      this.classList.toggle("tw:hidden");
      this.countryListModal.classList.toggle("active");
      return;
    }
    if (isInModalTrigger) {
      this.modal.classList.toggle("active");
      this.countryListModal.classList.toggle("active");
    } else {
      this.classList.toggle("tw:hidden");
      this.countryListModal.classList.add("active");
    }
  }
  initDataAndElements() {
    this.modal = this.querySelector("#geolocator-modal");
    this.closeModalButton = this.querySelector("#close-geolocator-modal");
    this.geolocatorScript = this.querySelector("#geolocator-script");
    this.countryDataArray = JSON.parse(this.geolocatorScript.innerHTML);
    this.geolocatorContentTemplate = this.querySelector("#geolocator-content-tempalte");
    this.geolocatorContentPlaceholder = this.querySelector("#geolocator-content-placeholder");
    this.countryListModal = this.querySelector("#geolocator-countrylist-modal");
    this.closeCountryListModalButton = this.querySelector("#close-geolocator-countrylist-modal");
    this.countryListButtons = Array.from(this.querySelectorAll(".countrylist-button"));
    this.countryListModalToggles = Array.from(document.querySelectorAll(".country-modal-toggle"));
    this.overlay = this.querySelector(".geolocator-overlay");
  }
  addEventListeners() {
    this.closeModalButton?.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggleGeolocator();
    });
    this.closeCountryListModalButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggleCountryListModal(this.closeCountryListModalButton);
    });
    this.countryListButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleCountryListButtonClick(button);
      });
    });
    this.countryListModalToggles.forEach((toggle) => {
      toggle?.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggleCountryListModal(toggle);
      });
    });
  }
  handleCountryListButtonClick(button) {
    setCookie("geolocation", button.dataset.handle, 30);
    const isMarket = button.dataset.type === "market";
    if (!isMarket) {
      const url = button.dataset.url;
      if (url) {
        window.location.href = url;
      } else {
        window.location.href = `${window.location.href}?geolocation=${button.dataset.handle}`;
      }
      return;
    }
    const { locale, handle } = button.dataset;
    this.handleMarketSwitch(handle, locale);
  }
  handleMarketSwitch(handle, locale) {
    const formId = crypto.randomUUID();
    const formElement = document.createElement("form");
    formElement.id = formId;
    formElement.action = "/localization";
    formElement.method = "POST";
    formElement.hidden = true;
    formElement.innerHTML = `
      <input name="_method" value="PUT">
      <input name="country_code" value="${handle}">
      <input name="language_code" value="${locale}">
      <input name="return_to" value="${window.location.href}?geolocation=${handle}">
    `;
    document.body.appendChild(formElement);
    formElement.submit();
  }
  getActiveCountryAndLanguage() {
    const { country, locale } = window.Shopify;
    return {
      country,
      locale
    };
  }
  getRecommendedMatch(browsingContext) {
    if (!browsingContext) return;
    const { suggestedCountry, suggestedLanguage, detectedCountry } = browsingContext;
    const countryHandle = suggestedCountry?.handle || detectedCountry?.handle;
    const languageHandle = suggestedLanguage?.handle;
    if (!countryHandle) return;
    const parseCountries = (countriesStr) => {
      if (!countriesStr) return [];
      return countriesStr.split(",").map((c) => c.trim().toUpperCase()).filter((c) => c.length > 0);
    };
    const isCountryInMarket = (market, country) => {
      const countries = parseCountries(market.countries || "");
      if (countries.length === 0) {
        return market.handle.toUpperCase() === country.toUpperCase();
      }
      return countries.includes(country.toUpperCase());
    };
    let recommendedMatch = this.countryDataArray.find((market) => isCountryInMarket(market, countryHandle) && market.locale === languageHandle);
    if (!recommendedMatch) {
      recommendedMatch = this.countryDataArray.find((market) => isCountryInMarket(market, countryHandle));
    }
    if (!recommendedMatch) {
      recommendedMatch = this.countryDataArray.find((market) => market.primary);
    }
    return recommendedMatch;
  }
  async getBrowsingContext() {
    const response = await fetch("/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true");
    const data = await response.json();
    const detectedValues = data.detected_values;
    const { handle, name } = detectedValues.country;
    const { suggestions } = data;
    let suggestedCountry = null;
    let suggestedLanguage = null;
    if (suggestions.length) {
      const suggestion = suggestions.find((_suggestion) => _suggestion.parts.country.handle === detectedValues.country.handle);
      suggestedCountry = suggestion?.parts.country;
      suggestedLanguage = suggestion?.parts.language;
    }
    const browsingContext = {
      detectedCountry: {
        handle,
        name
      },
      suggestedCountry,
      suggestedLanguage
    };
    return browsingContext;
  }
}
class UpsellPopup extends HTMLElement {
  modal = null;
  isOpen = false;
  handleCheckoutClick = async (e) => {
    const btn = e.target.closest('[name="checkout"]');
    if (!btn) return;
    const form = btn.closest("form");
    if (!form) return;
    if (!form.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      form.reportValidity();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      const itemCount = cart.item_count;
      if (itemCount >= 1 && itemCount <= 2) {
        const remainingEl = this.querySelector("[data-remaining-count]");
        if (remainingEl) remainingEl.textContent = String(3 - itemCount);
        this.show();
      } else {
        window.location.href = "/checkout";
      }
    } catch {
      window.location.href = "/checkout";
    }
  };
  handleKeydown = (e) => {
    if (e.key === "Escape") this.hide();
  };
  handleCartChange = () => {
    if (this.isOpen) this.hide();
  };
  connectedCallback() {
    this.modal = this.querySelector("[data-upsell-modal]");
    if (!this.modal) return;
    document.addEventListener("click", this.handleCheckoutClick, true);
    document.documentElement.addEventListener("cart:change", this.handleCartChange);
    this.modal.addEventListener("click", (e) => {
      const btn = e.target.closest("[aria-controls]");
      if (!btn) return;
      const quickBuyModal = this.modal?.querySelector(`#${btn.getAttribute("aria-controls")}`);
      if (!quickBuyModal || quickBuyModal.tagName.toLowerCase() !== "quick-buy-modal") return;
      e.preventDefault();
      e.stopPropagation();
      const productUrl = quickBuyModal.getAttribute("product-url");
      if (productUrl) window.location.href = productUrl;
    });
    this.modal.querySelector("[data-upsell-close]")?.addEventListener("click", (e) => {
      e.preventDefault();
      this.hide();
    });
    this.modal.querySelector("[data-upsell-backdrop]")?.addEventListener("click", () => {
      this.hide();
    });
    this.modal.querySelector("[data-upsell-checkout]")?.addEventListener("click", (e) => {
      e.preventDefault();
      window.location.href = "/checkout";
    });
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.handleCheckoutClick, true);
    document.removeEventListener("keydown", this.handleKeydown);
    document.documentElement.removeEventListener("cart:change", this.handleCartChange);
  }
  show() {
    if (!this.modal || this.isOpen) return;
    this.isOpen = true;
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer?.hasAttribute("open") && typeof cartDrawer.hide === "function") {
      cartDrawer.hide();
    }
    this.modal.classList.remove("tw:hidden");
    this.modal.classList.add("tw:flex");
    this.modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.handleKeydown);
  }
  hide() {
    if (!this.modal || !this.isOpen) return;
    this.isOpen = false;
    this.modal.classList.add("tw:hidden");
    this.modal.classList.remove("tw:flex");
    this.modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.handleKeydown);
  }
}
class VideoGrid extends HTMLElement {
  modal = null;
  stage = null;
  observer = null;
  abortController = null;
  activeItem = null;
  activeVideo = null;
  visibleItems = /* @__PURE__ */ new Set();
  reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  handleClick = (event) => {
    const button = event.target.closest("[data-video-grid-open]");
    const item = button?.closest("[data-video-grid-item]");
    const video = item?.querySelector("[data-video-grid-video]");
    if (!button || !item || !video) return;
    event.preventDefault();
    this.open(item, video, button);
  };
  handlePlaying = (event) => {
    const item = event.currentTarget.closest("[data-video-grid-item]");
    item?.setAttribute("data-playing", "");
  };
  handleIntersection = (entries) => {
    entries.forEach((entry) => {
      const item = entry.target;
      if (entry.isIntersecting) {
        this.visibleItems.add(item);
      } else {
        this.visibleItems.delete(item);
      }
      if (item === this.activeItem) return;
      const video = item.querySelector("[data-video-grid-video]");
      if (!video) return;
      if (this.shouldPlayInBackground(item)) {
        this.playMuted(video);
      } else {
        video.pause();
      }
    });
  };
  handleBeforeHide = () => {
    if (!this.activeItem || !this.activeVideo) return;
    this.activeVideo.muted = true;
    if (!this.activeItem.hasAttribute("data-autoplay")) {
      this.activeVideo.pause();
    }
  };
  handleAfterHide = () => {
    const item = this.activeItem;
    const video = this.activeVideo;
    this.activeItem = null;
    this.activeVideo = null;
    if (!item || !video) return;
    const slot = item.querySelector("[data-video-grid-slot]");
    if (slot) this.move(video, slot);
    video.controls = false;
    video.muted = true;
    if (!this.shouldPlayInBackground(item)) {
      video.pause();
      return;
    }
    if (video.paused) {
      this.playMuted(video);
    } else {
      item.setAttribute("data-playing", "");
    }
  };
  connectedCallback() {
    this.modal = this.querySelector("[data-video-grid-modal]");
    this.stage = this.querySelector("[data-video-grid-stage]");
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.addEventListener("click", this.handleClick, { signal });
    this.modal?.addEventListener("dialog:before-hide", this.handleBeforeHide, { signal });
    this.modal?.addEventListener("dialog:after-hide", this.handleAfterHide, { signal });
    this.querySelectorAll("[data-video-grid-video]").forEach((video) => {
      video.addEventListener("playing", this.handlePlaying, { signal });
    });
    const autoplayItems = this.querySelectorAll("[data-video-grid-item][data-autoplay]");
    if (autoplayItems.length > 0) {
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0.25 });
      autoplayItems.forEach((item) => this.observer?.observe(item));
    }
  }
  disconnectedCallback() {
    this.abortController?.abort();
    this.observer?.disconnect();
    this.observer = null;
    this.visibleItems.clear();
  }
  open(item, video, activator) {
    if (!this.modal || !this.stage || typeof this.modal.show !== "function") return;
    this.activeItem = item;
    this.activeVideo = video;
    item.removeAttribute("data-playing");
    this.stage.style.setProperty("--video-grid-aspect-ratio", item.style.getPropertyValue("--video-grid-aspect-ratio"));
    this.modal.show({ activator });
    this.move(video, this.stage);
    video.controls = true;
    video.muted = false;
    video.play().catch(() => {
      video.muted = true;
      video.play().catch(() => {
      });
    });
  }
  shouldPlayInBackground(item) {
    return item.hasAttribute("data-autoplay") && this.visibleItems.has(item) && !this.reducedMotion.matches;
  }
  playMuted(video) {
    video.muted = true;
    video.play().catch(() => {
    });
  }
  move(video, parent) {
    const target = parent;
    if (typeof target.moveBefore === "function") {
      try {
        target.moveBefore(video, null);
        return;
      } catch {
      }
    }
    parent.appendChild(video);
  }
}
customElements.define("geolocator-component", Geolocator);
customElements.define("upsell-popup", UpsellPopup);
customElements.define("video-grid", VideoGrid);
